import {
  easypostFedexMfaGeneratePinInputSchema,
  easypostFedexMfaGeneratePinOutputSchema,
} from "@redotech/redo-model/carrier-account/easypost-fedex-mfa";

export const easypostFedexMfaGeneratePin = {
  name: "easypostFedexMfaGeneratePin" as const,
  input: easypostFedexMfaGeneratePinInputSchema,
  output: easypostFedexMfaGeneratePinOutputSchema,
};
